export function shouldRenderFrame ({ now, lastRenderAt, maxFps }) {
  if (!lastRenderAt) return true
  if (!maxFps || maxFps >= 60) return true
  return now - lastRenderAt >= (1000 / maxFps)
}

export function bucketMarkersByOpacity (markers) {
  return markers.reduce((buckets, marker) => {
    const type = marker.type === 'click' ? 'click' : 'move'
    const key = String(Math.round(marker.opacity * 10) / 10)
    if (!buckets[type][key]) buckets[type][key] = []
    buckets[type][key].push({ x: marker.x, y: marker.y })
    return buckets
  }, { click: {}, move: {} })
}
